export const replaceUnderscoresAndSpacesWithHyphens = (string: string): string => {
  return string.replace(/, /g, '-').replace(/[_ ]/g, '-').toLowerCase();
};
